import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const revokeTokenOnLogout = (token) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.LOGIN.REVOKE_TOKEN_ON_LOGOUT,
    { token } // Wrap the token in an object
  );
};

export default revokeTokenOnLogout;
